var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_170107",
    "data-name": "Group 170107",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150969",
    "data-name": "Rectangle 150969",
    width: 80,
    height: 80,
    rx: 12,
    fill: "rgba(1,171,193,0.1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38745",
    "data-name": "Path 38745",
    d: "M12,64a12,12,0,0,0,0,24H28a12,12,0,0,0,0-24ZM31,75.5A2.5,2.5,0,1,1,33.5,73,2.5,2.5,0,0,1,31,75.5ZM29.5,79A2.5,2.5,0,1,1,27,76.5,2.5,2.5,0,0,1,29.5,79Zm-19-6.5a1.5,1.5,0,0,1,3,0v2h2a1.5,1.5,0,1,1,0,3h-2v2a1.5,1.5,0,1,1-3,0v-2h-2a1.5,1.5,0,1,1,0-3h2Z",
    transform: "translate(20 -36)",
    fill: "#01abc1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.112021ed8c7aaf4d5a374b324880c65c.svg";
export { ForwardRef as ReactComponent };